import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { API, errText, useAuth } from "@/lib/auth";
import { Link } from "react-router-dom";
import { paperChanged } from "./utils";

export const SidePicker = ({ m, side, setSide, prefix }) => (
  <div className="grid grid-cols-2 gap-2">
    {[["yes", m.yes_name, m.ask], ["no", m.no_name, m.bid != null ? 1 - m.bid : null]].map(([k, n, px]) => (
      <button key={k} onClick={() => setSide(k)} data-testid={`${prefix}-side-${k}`}
        className={`rounded-xl border px-3 py-2 text-sm text-left transition-colors ${side === k ? (k === "yes" ? "border-emerald-400 bg-emerald-500/10" : "border-red-400 bg-red-500/10") : "border-[var(--line)]"}`}>
        <div className="truncate font-semibold">{n}</div><div className="text-xs text-slate-400 font-num">buy at {px == null ? "—" : `${Math.round(px * 100)}¢`}</div>
      </button>
    ))}
  </div>
);

export const PaperBetForm = ({ m }) => {
  const { profile } = useAuth();
  const [side, setSide] = useState("yes");
  const [amt, setAmt] = useState("10");
  const [busy, setBusy] = useState(false);
  if (!profile) return <Link to="/account" className="btn-ghost w-full" data-testid="paper-signin-btn">Sign in to practice-bet with $1,000 paper money</Link>;
  const place = async () => {
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/predict/paper/bet`, { slug: m.slug, side, amount: Number(amt) });
      toast.success(`Practice bet placed: ${data.contracts} × ${data.side_name} for $${data.cost.toFixed(2)}`);
      paperChanged();
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3" data-testid="paper-bet-form">
      <SidePicker m={m} side={side} setSide={setSide} prefix="paper" />
      <div className="flex gap-2">
        <Input type="number" inputMode="decimal" value={amt} onChange={(e) => setAmt(e.target.value)} className="h-11 bg-[var(--bg)] border-[var(--line)] font-num" data-testid="paper-amount-input" />
        <button onClick={place} disabled={busy || !(Number(amt) > 0)} className="btn-primary shrink-0" data-testid="paper-bet-btn">{busy ? "Placing…" : "Practice bet"}</button>
      </div>
      <p className="text-[11px] text-slate-500">Paper money only. Fills at the live price plus Polymarket's fee, so results are realistic.</p>
    </div>
  );
};
